"use client";

import Image from "next/image";

import { useLoyaltyBrandContext } from "@saas/loyalty/feature/@context/loyalty-brand/loyalty-brand.context";
import { SpinnerIcon } from "@saas/shared/icon";

const LoadingPage = () => {
  const { brandName, logoUrl } = useLoyaltyBrandContext();

  return (
    <div
      className={
        "-mt-10 flex h-full w-full flex-col items-center justify-center gap-2 md:-mt-20"
      }
    >
      <div className={"flex items-center gap-2"}>
        <Image
          src={logoUrl}
          alt={`${brandName} logo`}
          width={120}
          height={30}
          objectFit={"contain"}
          priority={true}
        />

        <p className={"text-he headline-h2 mt-1 leading-7"}>Loyalti Program</p>
      </div>

      <div className={"flex flex-col items-center gap-4"}>
        <p className={"body-b3 text-le"}>
          Beli produk dan dapatkan banyak keuntungan
        </p>

        <SpinnerIcon className={"text-le h-8 w-8 animate-spin"} />
      </div>
    </div>
  );
};

export default LoadingPage;
